import React from "react";
import Events from "../Events";
import { DiaryFilterTypes } from '../../../types/index';

interface OwnTypes {
    filterData:Array<DiaryFilterTypes>, 
    title:string, 
    item:Array<any>, 
    type:string, 
    itemNames:Array<string>,
}

const NightWatchEvents = ({filterData, title, item, type, itemNames}: OwnTypes) => {
    return(
        <>
        {filterData.length === 0  &&
            <Events title={title} item={item} type={type} itemNames={itemNames} />
        }
        {filterData.length > 0 && item.length > 0 && filterData.find(fd => fd.value === 'nightwatch_reports') &&
            <Events title={title} item={item} type={type} itemNames={itemNames} />
        }
        </>
    )
}

export default NightWatchEvents;